export const ENGLISH_IQ_V2_STORAGE_KEY = 'cm_english_iq_session_v2';
